/* eslint-disable react/no-unescaped-entities */
/* eslint-disable semi */
import React, { Component } from "react"
import MetaTags from 'react-meta-tags'
import { Link } from "react-router-dom"
import { Container, Row, Col } from "reactstrap"

class Pages403 extends Component {
  render() {
    return (
      <React.Fragment>
  <div className="account-pages d-flex align-items-center justify-content-center min-vh-100">
    <MetaTags>
      <title>403 Forbidden Page</title>
    </MetaTags>
    <Container>
      <Row className="justify-content-center">
        <Col lg="12">
          <div className="text-center">
            <h1 className="display-2 fw-medium">
              4
              <i className="bx bx-buoy bx-spin text-primary display-3" />
              3
            </h1>
            <h4 className="text-uppercase">
              Sorry, You don't have permission to view this page
            </h4>
            <div className="mt-5">
              <Link className="btn btn-primary" to="/">
                Back to Dashboard
              </Link>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
</React.Fragment>

    )
  }
}

export default Pages403
